import * as React from "react";

function Logo(props) {
  return (
    <svg width={849} height={50} viewBox="0 0 849 148" {...props}>
      <style>{`
        .prop {
          fill: #171717;
        }
        .one {
          fill: #009f2b;
        }
      `}</style>
      <path
        d="M172.35 27.13v18.72h.32c25.78-40.24 88.09-19 87.2 27.68.85 46.54-61.69 67.79-87.2 27.52h-.32v46.08h-10.88v-120h10.88zm0 46.4c1.46 50.51 74.89 50.66 76.32 0-1.33-50.94-74.89-50.65-76.32 0zm141.76-49.12v11.84c-14.21.41-26.84 12-27.36 26.4v57.12h-10.88V27.13h10.88v14.72h.32c5.59-9.55 15.93-16.62 27.04-17.44zm51.68 87.52c50.17-1.18 50.19-75.8 0-77-50.27 1.59-50.1 75.4 0 77zm0 10.56c-65.19-2.17-65-95.78 0-98.08 65.1 2.21 65.08 95.87 0 98.08zM442 27.13v18.72h.32c25.78-40.24 88.09-19 87.2 27.68.85 46.54-61.69 67.79-87.2 27.52H442v46.08h-10.93v-120H442zm0 46.4c1.46 50.51 74.89 50.66 76.32 0-1.33-50.94-74.89-50.65-76.32 0zM24 54.77c-.07-15.69-23.93-15.7-24 0v37a11.999 11.999 0 1024 0v-37z"
        className="prop"
      />
      <path
        d="M590.55 111.93c50.28-1.45 50.3-75.53 0-77-50.39 1.87-50.21 75.12 0 77zm0 10.56c-36.46.63-61.45-40.56-43.28-72.4 19.33-35.87 73.19-33.26 88.73 4.48 14.23 30.9-11.66 68.91-45.44 67.92h-.01zm65.28-2.72V27.13h10.88v15.68h.29c10.46-19.17 39.27-24.46 56-10.48 8.28 7.12 12.18 18.28 11.92 29v58.4H724V61.37c.22-15.3-10.68-26.64-26.08-26.4-15.08 0-30.52 12.06-31.2 27.68v57.12h-10.89zm192.8-46.4l-.48 5.44h-85.92c5.11 35.25 50.89 45.25 69.6 14.56h12.32c-21.85 48.15-92.6 32.46-93.28-20 2.85-64.88 94.91-64.82 97.76 0zm-86.4-5.44h75c-7.02-43.56-68.01-43.65-75 0zM64 11.77c-.06-15.66-23.93-15.77-24 0v123c.06 15.65 23.93 15.72 24 0v-123zm40 31c-.07-15.68-23.93-15.71-24 0v61c.07 15.67 23.93 15.7 24 0v-61z"
        className="one"
      />
    </svg>
  );
}

export default Logo;
